import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { Checkbox } from '@/component/Checkbox/Checkbox';
import { SpecialIcon as ButtonIcon } from '@/component/Buttons/SpecialIcon/SpecialIcon';
import { PlusIcon } from '@/component/Icons/PlusIcon';
import { MinusIcon } from '@/component/Icons/MinusIcon';
import styles from './GuestsDropdown.module.css';

const data = [
  {
    name: 'adults',
    des: 'age-adult',
    type: 'adults',
    dataTestid: 'guests-adults-item',
  },
  {
    name: 'children',
    des: 'age-children',
    type: 'children',
    dataTestid: 'guests-children-item',
  },
  {
    name: 'infants',
    des: 'age-infant',
    type: 'infants',
    dataTestid: 'guests-infants-item',
  },
];

export const GuestsDropdown = ({
  onIncrement,
  onDecrement,
  onTogglePets,
  pets,
  guests,
  guestsLimit = Number.POSITIVE_INFINITY,
  isPetsAllowed = true,
}) => {
  const t = useTranslations();

  const handleTogglePets = useCallback(
    (e) => {
      onTogglePets(e.target.checked);
    },
    [onTogglePets],
  );
  const isLimitReached = guests.adults + guests.children >= guestsLimit;
  const isDisabledDecrement = (type) => {
    if (type === 'adults') return guests.adults <= 1;
    return guests[type] <= 0;
  };
  const isDisabledIncrement = (type) => {
    if (type === 'infants') return false;
    return isLimitReached;
  };

  return (
    <div className={`guests-dropdown ${styles.guest_dropdown_list}`}>
      {data.map((item) => {
        return (
          <div
            key={item.type}
            className={styles.list_block}
            data-testid={item.dataTestid}
          >
            <div>
              <div className={styles.guest_name}>{t(item.type)}</div>
              <div className={styles.dim_text}>{t(item.des)}</div>
            </div>
            <div className={styles.guest_counter}>
              <ButtonIcon
                onClick={() => onDecrement(item.type)}
                disabled={isDisabledDecrement(item.type)}
              >
                <MinusIcon />
              </ButtonIcon>
              <span
                className={styles.number}
                data-testid={`${item.dataTestid}-value`}
              >
                {guests[item.type]}
              </span>
              <ButtonIcon
                onClick={() => onIncrement(item.type)}
                disabled={isDisabledIncrement(item.type)}
              >
                <PlusIcon />
              </ButtonIcon>
            </div>
          </div>
        );
      })}

      {isPetsAllowed && (
        <div
          className={styles.footer}
          onClick={(e) => {
            e.preventDefault();
            onTogglePets();
          }}
        >
          <label>
            <Checkbox
              name="toggle-pets"
              value={pets}
              onChange={handleTogglePets}
            />
            <span className="flex flex-col justify-start">
              <span className="text-slate-800 text-[16px] leading-[12px] font-medium text-left">
                {t('pets-title')}
              </span>
              <span className="block text-slate-500 text-sm text-left mt-1 leading-4">
                {t('pets-desc')}
              </span>
            </span>
          </label>
        </div>
      )}
    </div>
  );
};
